import React from "react";

const Footer: React.FC = () => {
  return (
    <div className="flex flex-col items-center text-center px-5 py-2.5 bg-[#0D0D0C] mb-3 w-full">
      <img
        src="https://cdn.inito.com/rebrand_quiz/v1/logo/logoInito.svg"
        alt="logo"
        className="w-full h-auto mb-5 invert"
      />
      <p className="title-14 text-[#868686] w-full mt-5 text-left">
        &dagger; Inito is a medical device registered with the FDA and the
        return policy is to allow flexibility to the consumer while ensuring that
        products are safe and effective for us.
      </p>
      <p className="title-14 text-[#868686] w-full mt-5 text-left">
        1. &apos;Most precise&apos; refers to system-level precision measured in
        controlled laboratory testing, based on lower variability across key
        hormones, concentrations, operators, days, and strip lots. Compares Inito
        to other U.S. over-the-counter home fertility monitors that provide
        numeric or graded hormone values and measure the same hormones as Inito.
      </p>
      <p className="title-14 text-[#868686] mt-2.5 text-left">
        The following policy applies for purchases made through inito.com or the
        Inito App. If you purchased your product from Amazon or another
        authorized retailer, please speak with a representative from the
        original place of purchase as Inito must adhere to their policies and
        procedures. Products purchased through an unauthorized reseller are not
        eligible for any refund, cancellation, or replacement.
      </p>
      <p className="title-14 text-[#868686] mt-2.5 text-left">
        In order to be eligible for a refund, cancellation, or replacement from
        purchases made on inito.com, customers must provide proof of purchase.
        For prompt service, please email our Customer Care Team and provide your
        order number for any request for the following:
      </p>
      <div className="title-14 text-[#868686] mt-2.5 text-left">
        <ul className="ml-5 list-disc">
          <li>
            If your order has not shipped, you are eligible for a 100% refund of
            your inito.com order.
          </li>
          <li>
            Orders once shipped are not eligible for any return, refunds, or
            exchange.
          </li>
          <li>
            Damaged or defective products are covered by our 6-month limited
            warranty applicable from the date of purchase. During the warranty
            period, Inito will either repair or replace, at its option, any
            defective Product or part at no charge to you.
          </li>
        </ul>
        <p className="mt-2.5">
          <strong>
            &copy; {new Date().getFullYear()}, Inito Health Inc. All Rights Reserved.
          </strong>
        </p>
      </div>
    </div>
  );
};

export default Footer;
